export default {
  serverURI: '',
  fixedLayout: false,
  hideLogoOnMobile: false,
  project: 'sd012018',
  loginNameProject: 'BIODIGESTOR LAS CHILCAS',
  sideNameProject: 'BIO LAS CHILCAS',
  exibirGraficoInicial: true,
  iconeInterno: '../static/img/bi-logo-archea-biogas2.svg',
  grafico: {
    parametro: 'BiodigestorVazaoAcumulada',
    titulo: 'Gas consumido a partir del día',
    label: 'Gas consumido (m³)'
  },
  idioma: 'ES'
}



// WEBPACK FOOTER //
// ./src/config/index.js